"use client"

import { useSnapshot } from "valtio"
import { AccountState } from "../../stores/accountStore"

export function useIsReady() {
  const { ready } = useSnapshot(AccountState)
  return ready
}
